import help from '../../../images/help.png';
import './helpIcon.css';

import { Tooltip } from 'react-tooltip';

export default function HelpIcon({id, content}) {
    return (
        <>
            <img 
                src={help} 
                alt="" 
                data-tooltip-id={id} 
                data-tooltip-content={content} 
            />
            <Tooltip 
                id={id} 
                place="bottom-start"
                variant="light"
                opacity="1"
            />
        </>
    );
}